import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function AdminMenu() {
  const navigate = useNavigate();
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Admin Menu</Typography>
  <Button variant="contained" sx={{ mb: 1 }} fullWidth onClick={() => navigate('/admin/users')}>Manage Users</Button>
  <Button variant="contained" sx={{ mb: 1 }} fullWidth onClick={() => navigate('/admin/groups')}>Manage Groups</Button>
  <Button variant="contained" sx={{ mb: 1 }} fullWidth onClick={() => navigate('/admin/species')}>Manage Fish Species</Button>
      {/* Add more admin actions heere */}
    </Box>
  );
}
